import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Support() {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <button onClick={() => navigate(-1)} className="mb-8 text-indigo-600 hover:text-indigo-800 font-medium flex items-center gap-2">
          ← Volver
        </button>
        <h1 className="text-4xl font-bold mb-2">Support</h1>
        <p className="text-gray-500 mb-10">We're here to help you get the most out of AdPulse AI</p>

        <div className="prose prose-gray max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold mb-3">Contact Us</h2>
            <p className="text-gray-600 leading-relaxed mb-4">Our support team is available to assist you with any questions about the platform, integrations, or your account.</p>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <h3 className="font-semibold text-lg mb-3">📧 Email</h3>
                <a href="mailto:soporte@adpulseia.com" className="text-indigo-600 hover:underline text-lg">soporte@adpulseia.com</a>
                <p className="text-gray-500 text-sm mt-2">Response within 24 hours</p>
              </div>
              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <h3 className="font-semibold text-lg mb-3">📞 Phone</h3>
                <p className="text-gray-700"><a href="tel:+56940531363" className="text-indigo-600 hover:underline">+56 9 4053 1363</a> (Chile)</p>
                <p className="text-gray-700 mt-1"><a href="tel:+34671679251" className="text-indigo-600 hover:underline">+34 671 679 251</a> (Spain)</p>
                <p className="text-gray-500 text-sm mt-2">Mon-Fri 9:00 - 18:00</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Getting Started</h2>
            <div className="space-y-4">
              <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                <h3 className="font-semibold mb-2">1. Connect your ad platforms</h3>
                <p className="text-gray-600">Go to Clients, select your client, and connect Meta Ads, Google Ads, GA4, or Search Console via OAuth. Your data will sync automatically.</p>
              </div>
              <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                <h3 className="font-semibold mb-2">2. View your dashboard</h3>
                <p className="text-gray-600">Select a client from the workspace switcher and choose your date range. Campaign data loads from our database for instant access.</p>
              </div>
              <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                <h3 className="font-semibold mb-2">3. Campaign scoring & ranking</h3>
                <p className="text-gray-600">Each campaign receives a score (0-100) based on ROI, CTR, CPC, and volume. The ranking highlights your top and worst performers.</p>
              </div>
              <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                <h3 className="font-semibold mb-2">4. Chrome Extension</h3>
                <p className="text-gray-600">Install the AdPulse AI Chrome Extension for quick access to your campaign metrics directly from your browser toolbar.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">FAQ</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-gray-900">How often is the data updated?</h3>
                <p className="text-gray-600 mt-1">Campaign data syncs automatically every hour. You can also view real-time data by selecting "Today" in the date picker.</p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Can I manage multiple clients?</h3>
                <p className="text-gray-600 mt-1">Yes, you can create multiple clients and switch between them using the workspace selector. Each client has its own ad accounts and data.</p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">Is my data secure?</h3>
                <p className="text-gray-600 mt-1">Yes, we use OAuth 2.0 for all platform connections. We never store your ad platform passwords. All data is encrypted in transit and at rest.</p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900">What platforms are supported?</h3>
                <p className="text-gray-600 mt-1">Currently we support Meta Ads (Facebook & Instagram), Google Ads (coming soon), Google Analytics 4, and Google Search Console.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">Office</h2>
            <div className="text-gray-600 space-y-1">
              <p>📍 Lago Bertrand 115, Piso 1024</p>
              <p>Quilpué, Región de Valparaíso, Chile</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
